import io from 'socket.io-client'

export const connectedSocket = (placeId, accessToken) => {
  const socket = io(`${process.env.REACT_APP_API_SOCKET}/auth`, {
    query: `placeId=${placeId}`,
    auth: {
      accessToken,
    },
    transports: ['websocket', 'polling'],
  })
  return socket
}
